<template>
  <div class="kpt-group-entity-selector">
    <b-taglist>
      <b-tag v-for="(entity, idx) in selectedEntities"
        :key="idx"
        type="is-primary"
        closable
        closeType='is-danger'
        aria-close-label="Close"
        @close="deselectEntity(entity)">
        {{ parseTagValue(entity) }}
      </b-tag>
    </b-taglist>
    <div v-if="groupEntityType == 'remote'"> 
      <remotes-selector ref="remote" @item-select="entitySelected" :is-multiple-select="true" :pre-selected="preSelected" :account-filter="groupOwner"></remotes-selector>
    </div>
    <div v-if="groupEntityType == 'device'"> 
      <devices-selector ref="device" @item-select="entitySelected" :is-multiple-select="true" :pre-selected="preSelected" :account-filter="groupOwner"></devices-selector>
    </div>
    <div v-if="groupEntityType == 'subscription'"> 
      <subscriptions-selector ref="subscription" @item-select="entitySelected" :is-multiple-select="true" :pre-selected="preSelected" :account-filter="groupOwner"></subscriptions-selector>
    </div>
  </div>
</template>

<script>
import RemotesSelectorComponent from '../../remotes/components/RemotesSelectorComponent.vue';
import DevicesSelectorComponent from '../../devices/components/DevicesSelectorComponent.vue';
import SubscriptionsSelectorComponent from '../../subscriptions/components/SubscriptionsSelectorComponent.vue';

export default {
  data() {
    return {
      selectedEntities: []
    }
  },
  props: {
    groupOwner: String,
    groupEntityType: String,
    preSelected: {
      type: Array,
      default: () => []
    }
  },
  components: {
    'remotes-selector': RemotesSelectorComponent,
    'devices-selector': DevicesSelectorComponent,
    'subscriptions-selector': SubscriptionsSelectorComponent
  },
  mounted() {
    if (this.preSelected) {
      this.selectedEntities = this.preSelected;
    }
  },
  methods: {
    refreshEntities() {
      // refresh the list of available entities
      this.$refs[this.groupEntityType].reset();
    },
    deselectEntity(entity) {
      // deselect the corresponding row if a tag is "closed" 
      this.$refs[this.groupEntityType].unselectItem(entity);
    },
    entitySelected(selected) {
      this.selectedEntities = selected;
      this.$emit('entity-selected', selected);
    },
    parseTagValue(entity) {
      // output is the value displayed in the tags for selected items
      switch (this.groupEntityType) {
        case 'remote':
          return entity.name;
        case 'device':
          return entity.serial;
        case 'subscription':
          return `${entity.displayId} - ${entity.productName}`;
        default:
          return 'Unknown Entity Type';
      }
    }
  }
}
</script>

<style lang="scss" scoped>
  .kpt-group-entity-selector {

  }
</style>
